<template>
  <div class="max-w-3xl">
    <form @submit.prevent="submit">
      <div class="mt-2 flex flex-col mt-8">
        <TextInput label="Title" v-model="form.title" :errors="$page.props.errors.title"></TextInput>
      </div>

      <div class="mt-2 flex flex-col mt-8">
        <TextInput label="Banner Link" v-model="form.link" :errors="$page.props.errors.link"></TextInput>
      </div>

      <div class="mt-4 pr-6 pb-4 w-full lg:w-1/2">
        <div class="text-base mb-2">Upload Image</div>
        <div v-if='formData.image_url' class="border bg-contain bg-no-repeat bg-bottom h-32 bg-white block mt-2" :style="`background-image: url(${formData.image_url});`"></div>
        <file-input  :errors="$page.props.errors.image" v-model="form.image" help="image max dimension 580 x 270, max file size 300kb"></file-input>
      </div>


      <div class="mt-2 flex flex-col mt-8">
        <div>
          <SelectInput label="Publish" v-model="form.publish" class="mt-8">
            <option :value="true">Yes</option>
            <option :value="false">No</option>
          </SelectInput>
        </div>
      </div>

      <div class="mt-8">
          <div class="flex rounded-md shadow-sm flex justify-between">

            <button type="button"  @click.prevent="deleteAction" v-if="deleteAction" class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-red-600 hover:bg-red-600 focus:outline-none focus:border-red-700 focus:shadow-outline-red active:bg-red-700 transition ease-in-out duration-150">
              <span>Delete</span>
            </button>

            <button type="button" @click="submit" class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150">
              <span v-if="processing">...please wait</span>
              <span v-else>Submit</span>
            </button>
          </div>
      </div>
    </form>
  </div>
</template>

<script>
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import FileInput from '@/Shared/FileInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  name: 'Form',
  components: {SelectInput, TextInput, FileInput, LoadingButton},
  props: {
    processing: {
      type: Boolean,
      default: false
    },
    deleteAction: {
      default: null
    },
    formData : {
      type: Object,
      default: () => ({
        label: '',
        link: '',
        publish: true,
      }),
    },
  },
  data() {
    return {
      form: this.formData
    }
  },

  methods: {
    submit() {
      this.$emit('submit', this.form)
    },

    handleDeleteAction() {
      this.deleteAction();
    }
  }



}
</script>
